import React, { lazy } from 'react'
import {
    CBadge,
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CCallout
} from 'compat/coreui'

const Upgrade = () => {
    return (
        <>
            <CRow className="text-center">
                <CCol md sm="12" className="mb-sm-2 mb-0">
                    <CCard className="p-5 text-left">
                        <h1>Account Info</h1>
                        <div>
                            <strong className="pl-2 pr-3">Current Package:</strong>
                            <strong className="text-muted">29.703 Users (40%)</strong>
                        </div>
                        <div>
                            <strong className="pl-2 pr-3">Next Due:</strong>
                            <strong className="text-muted">(unknown)</strong>
                        </div>
                        <div>
                            <strong className="pl-2 pr-3">Current Price:</strong>
                            <strong className="text-muted">$0.00</strong>
                        </div>
                    </CCard>

                </CCol>
                <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
                    <CCard className="p-5 text-left">
                        <h1>Account Representative</h1>
                        <div>
                            <strong className="pl-2 pr-3">Name:</strong>
                            <strong className="text-muted">Gus</strong>
                        </div>
                        <div>
                            <strong className="pl-2 pr-3">Phone:</strong>
                            <strong className="text-muted">9627029224</strong>
                        </div>
                        <div>
                            <strong className="pl-2 pr-3">Email:</strong>
                            <strong className="text-muted">29.703 Users (40%)</strong>
                        </div>
                    </CCard>
                </CCol>

            </CRow>
            <div className="wrapper">
                <CRow className="text-center m-auto">
                    <CCol lg={4}>
                        <CCard className="grid_column1 featured value selected1 p-5" >
                            <div className="title1" ><h2>PREMIUM</h2></div>
                            <span className="price1">$3000<span>/mo</span></span>
                            <ul className="details" style={{ textAlign: "start", marginTop: "10%" }}>
                                <li><strong>15 Mile Local</strong> Exposure</li>
                                <li><strong>Premium</strong> Map Icon</li>
                                <li><strong>Advanced</strong> Menus &amp; Products</li>
                                <li><strong>Promoted</strong> Daily Deals</li>
                                <li>Page 1 of Results</li>
                                <li>Online Pre-Ordering</li>
                                <li>Business Analytics </li>
                                <li>Call Tracking</li>
                                <li>Marketing Materials</li>
                            </ul>
                            <div className="cta">
                                <div>
                                    <CButton color="warning" className="m-3 pl-5 pr-5 text-white">TRY</CButton>
                                    <CButton color="success" className="m-3 pl-5 pr-5" >BUY</CButton>
                                </div>
                                <span className="trial">7 DAY FREE TRIAL!</span>
                            </div>
                        </CCard>
                    </CCol>
                    <CCol lg={4}>
                        <CCard className="grid_column1 premium1 p-5 p-5" >
                            <div className="title1"><h2>FEATURED</h2></div>
                            <span className="price1" >$1,300<span>/mo</span></span>
                            <ul className="details" style={{ textAlign: "start", marginTop: "10%" }}>
                                <li><strong>10 Mile Local</strong> Exposure</li>
                                <li><strong>Featured</strong> Map Icon</li>
                                <li><strong>Advanced</strong> Menus &amp; Products</li>
                                <li><strong>Promoted</strong> Daily Deals</li>
                                <li>Page 1 of Results</li>
                                <li>Online Pre-Ordering</li>
                                <li>Business Analytics </li>
                                <li>Call Tracking</li>
                                <li>Marketing Materials</li>
                            </ul>
                            <div className="cta">
                                <div>
                                    <CButton color="warning" className="m-3 pl-5 pr-5 text-white" >
                                        TRY
                                    </CButton>
                                    <CButton color="success" className="m-3 pl-5 pr-5" >
                                        BUY
                                    </CButton>
                                </div>
                                <span className="trial">7 DAY FREE TRIAL!</span></div>
                        </CCard>
                    </CCol>
                    <CCol lg={4}>
                        <CCard className="grid_column1 verified1 p-5">
                            <div className="title1"><h2>VERIFIED</h2></div>
                            <span className="price1">$650<span>/mo</span></span>
                            <ul className="details" style={{ textAlign: "start", marginTop: "10%" }}>
                                <li><strong>5 Mile Local</strong> Exposure</li>
                                <li><strong>Verified</strong> Map Icon</li>
                                <li><strong>Advanced</strong> Menu &amp; Products</li>
                                <li><strong>Promoted</strong> Daily Deals</li>
                                <li>Page 1 of Results</li>
                                <li>Online Pre-Ordering</li>
                                <li>Business Analytics </li>
                                <li>Call Tracking</li>
                                <li>Marketing Materials</li>
                            </ul>
                            <div className="cta">
                                <CButton color="success" className="pl-5 pr-5 mt-4">BUY</CButton>
                                <div style={{ height: '32px' }} />
                            </div>
                        </CCard>
                    </CCol>
                </CRow>
            </div>
        </>
    )
}

export default Upgrade
